import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { WasThisHelpfullProps } from "./WasThisHelpfull"
import { feedbackCache } from "cache/feedbackCache"
import FeedbackAnalytics from "analytics/FeedbackAnalytics"
import MeetingAnalytics from "analytics/MeetingAnalytics"
import ModalState from "reusable/mobx-helpers/ModalState"
import { formHandler, FormHandlerConfig } from "reusable/mobx-store-utils/form-handlers/new/form-handler"
import { snackbarSuccess } from "reusable/mui/snackbar/snackbar"
import { FeedbackRatingEnum, feedbackQuestionsSchema } from "@gap/backend/app-services/feedback/models/FeedbackTypeEnum"
import { apiClientSilent } from "api/trpc/trpc-client"

export default class WasThisHelpfullStore {
   sp
   canSubmitFeedback = false // If true the user has previsously submitted feedback
   hasSubmittedFeedback = false // if true the user has just submitted feedback
   improveDialog = new ModalState({
      onClose: () => {
         this.sp.onClose?.()
      }
   })
   fields: Record<string, string>
   feedback: FeedbackRatingEnum

   constructor(sp: WasThisHelpfullProps) {
      this.sp = sp

      const questions = feedbackQuestionsSchema[sp.type]
      this.fields = questions.reduce((acc, key) => {
         acc[key] = ''
         return acc
      }, {} as Record<string, string>)

      if (sp.skipToImproveDialog) {
         this.improveDialog.open()
      }
   }

   get formHandler() {
      const questions = feedbackQuestionsSchema[this.sp.type]
      const config = questions.reduce((acc, key) => {
         acc[key] = { type: 'string' }
         return acc
      }, {} as Record<string, { type: 'string' }>)

      return formHandler(this.fields, config satisfies FormHandlerConfig)
   }

   submitGoodFeedback = () => {
      this.feedback = 'good'
      this.submitFeedback()
   }

   submitBadFeedback = () => {
      this.feedback = 'bad'
      this.submitFeedback()
   }

   submitImprovement = () => {
      this.improveDialog.close()
      this.canSubmitFeedback = false
      snackbarSuccess('Thanks, your feedback has been submitted.')
      FeedbackAnalytics.improvement({
         type: this.sp.type,
         ...this.fields
      })
      apiClientSilent.feedback.submit.mutate({
         rating: this.feedback || 'not specified',
         entityId: this.sp.entityId,
         type: this.sp.type,
         questions: this.fields
      })
   }

   private submitFeedback = () => {
      this.hasSubmittedFeedback = true
      if (!feedbackQuestionsSchema[this.sp.type].length) {
         this.canSubmitFeedback = false
      }
      FeedbackAnalytics.feedback({
         feedback: this.feedback,
         type: this.sp.type
      })
      if (this.sp.aiFeedback && (this.feedback === 'good' || this.feedback === 'bad')) {
         MeetingAnalytics.aiFeedbackGiven({
            sentiment: this.feedback === 'good' ? 'Good' : 'Bad',
            comment: '',
            ...this.sp.aiFeedback,
         })
      }
      apiClientSilent.feedback.submit.mutate({
         rating: this.feedback || 'not specified',
         entityId: this.sp.entityId,
         type: this.sp.type,
      })
      feedbackCache.documentSummary.set([...feedbackCache.documentSummary.get() || [], this.sp.entityId])
   }
}

export const { Provider: WasThisHelpfullStoreProvider, useProvidedStore: useWasThisHelpfullStore } = createStoreContext(WasThisHelpfullStore)
